import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from '@syneto/compass-react';

// Mirrors src/pages/Dashboard/components/PartnerPreviewBanner: the "Dismiss" button and the
// close icon are two separate affordances sharing one handler, both persisting the same
// dismissal. The parent owns the dismissal request/state (Inventory/index.js) because the same
// dismissal data also drives the OS column header icon.
export const LegacyOSVersionBanner = (props) => {
	const { onDismiss } = props;

	return (
		<Alert variant="warning" className="d-flex justify-content-between align-items-center mb-3" dismissible closeLabel="Close" onClose={onDismiss}>
			<div>Warning: OS versions before 5.4.4 might not be reported correctly. Please upgrade.</div>
			<Button role="secondary" className="flex-shrink-0 ms-4" onClick={onDismiss}>Dismiss</Button>
		</Alert>
	);
};

LegacyOSVersionBanner.propTypes = {
	onDismiss: PropTypes.func.isRequired,
};
